import { Dispatch } from 'redux';
import ApiService from '@/services/ApiService';
import t from '@/store/types';

export const submitOptions = ({ form }: { form: any }) => {
  return (dispatch: Dispatch) => {
    return ApiService.post('settings', form).then((response) => {
      dispatch({
        type: t.SETTING_SET,
        options: form.options,
      });
      return response;
    });
  };
};

export const FetchOptions = ({ form }: { form?: any } = {}) => {
  return (dispatch: Dispatch) =>
    new Promise((resolve, reject) => {
      ApiService.get('settings')
        .then((response) => {
          dispatch({
            type: t.SETTING_SET,
            options: response.data.settings,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
};

export const setSettings = (settings: any) => {
  return {
    type: t.SETTING_SET,
    options: settings,
  };
};

export const addSettings = (group: any, key: any, value: any) => {
  return {
    type: t.SETTING_ADD,
    payload: { group, key, value },
  };
};
